import { Injectable } from "@angular/core";
import { JwtHelperService } from '@auth0/angular-jwt';
import { AccessPolicies, Claim, IdentityUser } from './identity.models';
import { AuthService } from "./auth.service";

@Injectable()
export class IdentityService
{
	private user: IdentityUser;

	constructor(private jwtHelper: JwtHelperService)
	{
	}

	// get logged identity user
	getUser(): IdentityUser
	{
		console.log(this.user);

		// setting user from token
		if (!this.user)
		{
			// decoding token payload
			const tokenPayload = this.jwtHelper.decodeToken(AuthService.getAccessToken());


			console.log(AuthService.getAccessToken());
			console.log(tokenPayload);

			// loading user info
			if (tokenPayload)
			{
				console.log(tokenPayload[Claim.CerSupplyId]);

				this.user = new IdentityUser();
				this.user.id = tokenPayload[Claim.NameIdentifier];
				this.user.username = tokenPayload[Claim.Name];
				this.user.firstName = tokenPayload[Claim.GivenName];
				this.user.lastName = tokenPayload[Claim.Surname];
				this.user.email = tokenPayload[Claim.EmailAddress];
				this.user.sysAdmin = tokenPayload[Claim.SysAdmin] === 'false' ? false : true;
				this.user.language = tokenPayload[Claim.Language];
				this.user.adUser = tokenPayload[Claim.AdUser] === 'false' ? false : true;
				this.user.cerSupplyId = tokenPayload[Claim.CerSupplyId];
				this.user.cerMemberId = tokenPayload[Claim.CerMemberId];
				this.user.policies = JSON.parse(tokenPayload[Claim.Policies]);
			}
		}

		return this.user;
	}

	// verify current user has policy
	hasPolicy(alias: AccessPolicies): boolean
	{
		// get current user
		const user: IdentityUser = this.getUser();

		if (user)
		{
			if (!user.sysAdmin)
				return user.policies.indexOf(AccessPolicies[alias].toString()) >= 0;
			else
				return true;
		}
		else
			return false;
	}

	// reset cached user data
	resetUser()
	{
		this.user = null;
	}
}